import UserTag from "../../../models/userTag";
import AddRemoveTagsAction from "./AddRemoveTagsAction";

export default class AddRemoveTagsData {
  public tagAction: AddRemoveTagsAction = AddRemoveTagsAction.AddTags;
  public userTags: UserTag[] = [];
}
